<template>
  <p role="status">
    <span class="sr-only">
      {{ t('text', {shown, total}) }}
    </span>
    <i18n-t
      tag="span"
      keypath="text"
      class="flex-1 text-right whitespace-nowrap text-base leading-tight text-gray-700"
      aria-hidden="true"
    >
      <template v-slot:shown>
        <strong>{{ shown }}</strong>
      </template>
      <template v-slot:total>
        <strong>{{ total }}</strong>
      </template>
    </i18n-t>
  </p>
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';

defineProps<{
  shown: number;
  total: number;
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
    "text": "Showing {shown} of {total} results"
  },
  "fr": {
    "text": "Affichage de {shown} sur {total} résultats"
  }
}

</i18n>
